import React, { FunctionComponent } from 'react';
import '../../productPage/producthome.css';
import * as styles from '../../productPage/tableComponents/ProductPage_style';
import ReusableTabs from '../../common/ReusableTabs';
import ToolPage from './ToolPage';
import BreadCrumbs from '../../common/BreadCrumbs';
import { PrefilteredResourceLibraryItemsProvider } from '../../../graphql/pimcore/modules/resourceLibrary/contexts/PrefilteredResourceLibraryItemsProvider';
import TechnicalResources from '../../automotivePage/TechnicalResources';

import { SalesAndResourcesSimulationToolsContent } from '../../../graphql/pimcore/modules/siteContent/types/SalesAndResourcesSimulationToolsContent';

interface SimulationHomeProps {
    cmsContent: SalesAndResourcesSimulationToolsContent;
}

const SimulationHome: FunctionComponent<SimulationHomeProps> = ({ cmsContent }) => {
    return (
        <ReusableTabs
            bannerImage={cmsContent.pageTitleBackgroundImage.imageUrl}
            bannerTitle={cmsContent.pageTitle.content}
            bannerDescription={cmsContent.pageSubtitle.content}
            tabLabels={[cmsContent.Overview.title.content, cmsContent.Resources.title.content]}
            tabKeys={['Overview', 'Resources']}
            tabContents={[
                <ToolPage key="overview" cmsContent={cmsContent.Overview} />,
                <PrefilteredResourceLibraryItemsProvider
                    key="resources"
                    initialFilters={{
                        resourceTypeKeys: ['Simulation Tools'],
                    }}
                >
                    <TechnicalResources backgroundColor={'white'} />
                </PrefilteredResourceLibraryItemsProvider>,
            ]}
            bannerFontStyle={styles.bannerFont}
            subBannerFontStyle={styles.SIMULATION_SUB_BANNER_FONT}
            pageName={'simulation'}
            showTabs={true}
            breadcrumbs={<BreadCrumbs navigationPath="/Home/SalesAndResources/SimulationTools" />}
        />
    );
};

export default SimulationHome;
